import { useEntregador } from "../context/EntregadorContext";
import EntregadorCard from "../components/EntregadorCard";
import { Users, Play } from "lucide-react";
import { useCreateFilaEntrega } from "../../../hooks/useFilaEntrega";
import { Usuario } from "../../../types/usuario";

const IniciarDia = () => {
  const { entregadoresSemFila, handleIniciarDia } = useEntregador();
  const createFilaMutation = useCreateFilaEntrega();

  if (entregadoresSemFila.length === 0) {
    return (
      <div className="rounded-lg border border-neutral-200 bg-white p-6 text-center sm:p-8">
        <Users className="mx-auto mb-4 text-neutral-400" size={48} />
        <p className="text-sm text-neutral-500 sm:text-base">
          Todos os entregadores já iniciaram o dia.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {entregadoresSemFila.map((entregador: Usuario) => (
        <EntregadorCard
          key={entregador.id}
          entregador={entregador}
          variant="iniciar"
          onAction={() => handleIniciarDia(entregador.id)}
          isActionLoading={createFilaMutation.isPending}
          actionText={
            createFilaMutation.isPending ? "Iniciando..." : "Iniciar Dia"
          }
          actionIcon={<Play size={16} />}
        />
      ))}
    </div>
  );
};

export default IniciarDia;
